import { render, staticRenderFns } from "./MessengerPage.vue?vue&type=template&id=28c4b452&"
import script from "./MessengerPage.vue?vue&type=script&lang=js&"
export * from "./MessengerPage.vue?vue&type=script&lang=js&"
import style0 from "./MessengerPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports